<template>
    <div>
        <base-header type="gradient-default" class="pb-7 pt-5 pt-md-8"></base-header>

        <div class="container-fluid mt--9">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-12 text-center">
                                    <base-dropdown>
                                        <base-button slot="title" type="default" class="dropdown-toggle text-uppercase">
                                            {{mesAtual}}
                                        </base-button>
                                        <a v-for="(mes, index) in menses" :key="index"
                                           @click="alterPagina(index, filtro.ano)"
                                           style="cursor: pointer"
                                           class="dropdown-item text-uppercase">{{mes}}
                                        </a>
                                    </base-dropdown>
                                    <base-dropdown>
                                        <base-button slot="title" type="default" class="dropdown-toggle">
                                            {{filtro.ano}}
                                        </base-button>
                                        <a v-for="(ano, index) in anos" :key="index"
                                           @click="alterPagina(filtro.mes, ano.ano)"
                                           style="cursor: pointer"
                                           class="dropdown-item text-uppercase">{{ano.ano}}
                                        </a>
                                    </base-dropdown>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div v-if="calendarAction">
                                        <ContentLoader
                                                :speed=2
                                                :width=883
                                                :height=575
                                                viewBox="0 0 883 575"
                                                backgroundColor="#f3f3f3"
                                                foregroundColor="#ecebeb">
                                            <rect x="350" y="1" rx="0" ry="0" width="180" height="30"/>
                                            <rect x="12" y="35" rx="2" ry="2" width="883" height="25"/>

                                            <rect x="12" y="65" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="140" y="65" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="268" y="65" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="396" y="65" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="524" y="65" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="524" y="65" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="652" y="65" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="780" y="65" rx="2" ry="5" width="120" height="100"/>

                                            <rect x="12" y="170" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="140" y="170" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="268" y="170" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="396" y="170" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="524" y="170" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="524" y="170" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="652" y="170" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="780" y="170" rx="2" ry="5" width="120" height="100"/>

                                            <rect x="12" y="275" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="140" y="275" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="268" y="275" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="396" y="275" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="524" y="275" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="524" y="275" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="652" y="275" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="780" y="275" rx="2" ry="5" width="120" height="100"/>

                                            <rect x="12" y="380" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="140" y="380" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="268" y="380" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="396" y="380" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="524" y="380" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="524" y="380" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="652" y="380" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="780" y="380" rx="2" ry="5" width="120" height="100"/>

                                            <rect x="12" y="485" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="140" y="485" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="268" y="485" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="396" y="485" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="524" y="485" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="524" y="485" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="652" y="485" rx="2" ry="5" width="120" height="100"/>
                                            <rect x="780" y="485" rx="2" ry="5" width="120" height="100"/>

                                        </ContentLoader>
                                    </div>
                                    <table v-if="!calendarAction" id="calendar">
                                        <caption class="text-uppercase text-dark">{{mesAtual}} de {{filtro.ano}}
                                        </caption>
                                        <tr class="weekdays">
                                            <th scope="col">Domingo</th>
                                            <th scope="col">Segunda</th>
                                            <th scope="col">Terça</th>
                                            <th scope="col">Quarta</th>
                                            <th scope="col">Quinta</th>
                                            <th scope="col">Sexta</th>
                                            <th scope="col">Sábado</th>
                                        </tr>
                                        <tr v-for="(semana, index) in calendar" :key="index" class="days">
                                            <td v-for="(day, index2) in semana.days" :key="index2" class="day"
                                                v-bind:class="[day.no_mes ? 'other-month' : 'other-month-off']">
                                                <div v-show="day.day" class="date">{{day.day}}</div>
                                                <div v-show="day.dia_numero" class="event">
                                                    <div class="event-desc">
                                                        <router-link v-if="day.dia_numero" ref="link"
                                                                     :to="{name: 'diario', params: {dia_numero: day.dia_numero}}">
                                                            {{day.dia_numero | padDigits}}
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import {ContentLoader} from "vue-content-loader"
  import moment from 'moment-timezone'
  import {mesesName} from '../plugins/webdom'
  import {getAnos, getCalendario} from '../api/pesquisa';

  export default {
    components: {
      ContentLoader
    },
    data() {
      return {
        calendarAction: false,
        filtro_calendar: {
          startDay: moment().clone().startOf('month').startOf('week'),
          endDay: moment().clone().endOf('month').endOf('week')
        },
        filtro: {
          mes: moment().month(),
          ano: moment().year()
        },
        anos: [],
        calendar: []
      }
    },
    methods: {
      calendario(diarios) {
        let aux_calendar = [];
        let date = this.filtro_calendar.startDay.clone().subtract(1, 'day');

        while (date.isBefore(this.filtro_calendar.endDay, 'day')) {
          aux_calendar.push({
            days: Array(7).fill(0).map(() => date.add(1, 'day').clone())
          })
        }
        aux_calendar.forEach((semana) => {
          semana.days.forEach((dia, inx_dia) => {
            let day = {day: null}
            let diario = diarios.filter((d) => {
              return d.dia_data_publicacao === parseInt(dia.format('D'))
            });
            if (diario[0]) {
              day = {
                day: dia.format('DD'),
                no_mes: true,
                dia_codigo: diario[0].dia_codigo,
                dia_numero: diario[0].dia_numero
              }
            } else {
              if (parseInt(this.filtro.mes) === parseInt(dia.month())) {
                day = {day: dia.format('DD'), no_mes: true, dia_codigo: null, dia_numero: null}
              } else {
                day = {day: dia.format('DD'), no_mes: false, dia_codigo: null, dia_numero: null}
              }
            }
            semana.days[inx_dia] = day;
          });
        });
        this.calendar = aux_calendar;
        this.calendarAction = false;
      },
      listAnos() {
        getAnos().then(response => {
          if (response.status) {
            this.anos = response.data
          }
        });
      },
      listCalendario() {
        this.calendarAction = true;
        getCalendario(this.filtro).then(response => {
          if (response.status) {
            this.calendario(response.data);
          }
        }).catch(error => {
          this.calendarAction = false;
        })
      },
      alterPagina(mes, ano) {
        this.$router.push({name: 'calendario', query: {mes: mes, ano: ano}})
      },
      atualizaQuery() {
        if (this.$route.query.ano) {
          this.filtro.mes = this.$route.query.mes;
          this.filtro.ano = this.$route.query.ano;
          const query_date = moment().year(this.filtro.ano).month(this.filtro.mes).date(15);
          this.filtro_calendar.startDay = query_date.clone().startOf('month').startOf('week');
          this.filtro_calendar.endDay = query_date.clone().endOf('month').endOf('week');
        } else {
          this.filtro.mes = moment().month();
          this.filtro.ano = moment().year();
          this.filtro_calendar.startDay = moment().clone().startOf('month').startOf('week');
          this.filtro_calendar.endDay = moment().clone().endOf('month').endOf('week');
        }
        this.listCalendario();
      }
    },
    created() {
      this.listAnos();
      this.atualizaQuery()
    },
    computed: {
      mesAtual() {
        return mesesName(this.filtro.mes);
      },
      menses() {
        return mesesName(null, true);
      }
    },
    watch: {
      '$route.query'() {
        this.atualizaQuery()
      }
    }
  };
</script>
<style>
    /* declare a 7 column grid on the table */
    #calendar {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
    }

    #calendar tr, #calendar tbody {
        grid-column: 1 / -1;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        width: 100%;
    }

    caption {
        text-align: center;
        grid-column: 1 / -1;
        font-size: 130%;
        font-weight: bold;
        padding: 10px 0;
    }

    #calendar a {
        color: #f7fafc;
        text-decoration: none;
    }

    #calendar td, #calendar th {
        padding: 5px;
        box-sizing: border-box;
        border: 1px solid #ccc;
    }

    #calendar .weekdays {
        background: #192d4f;
    }

    #calendar .weekdays th {
        text-align: center;
        text-transform: uppercase;
        line-height: 10px;
        border: none !important;
        padding: 10px 6px;
        color: #fff;
        font-size: 12px;
    }

    #calendar td {
        min-height: 100px;
        display: flex;
        flex-direction: column;
    }

    #calendar .days li:hover {
        background: #d3d3d3;
    }

    #calendar .date {
        font-weight: 400;
        text-align: center;
        margin-bottom: 5px;
        padding: 4px;
        color: #333;
        flex: 0 0 auto;
        align-self: flex-end;
    }

    #calendar .event {
        flex: 0 0 auto;
        font-size: 13px;
        border-radius: 4px;
        padding: 5px;
        margin-bottom: 5px;
        line-height: 14px;
        background: #192d4f;
        border: 1px solid #f8f9fe;
        text-decoration: none;
    }

    #calendar .event-desc {
        color: #666;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        margin: 10px 0 15px 0;
        text-decoration: none;
    }

    #calendar .other-month {
        background: #ffffff;
        color: #666;
    }

    #calendar .other-month-off {
        background: #e6e6e6;
        color: #666;
    }
</style>
